import { Box, CardActions, CardHeader, Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle, IconButton, Theme } from '@mui/material';
import * as React from 'react';
import {Card as MuiCard, CardContent} from '@mui/material';
import Icon from 'components/icons/Icon';
import SubHeading from 'components/labels/SubHeading';
import Button from 'components/buttons/Button';
import Container from 'components/layout/Container';
import Dialog from './Dialog';
import { ColorsUtil, ColourType, MyTheme } from 'MyTheme';
import LoadingButton from 'components/buttons/LoadingButton';
import { useState } from 'react';
import Login from 'views/authentication/Login';
import LoginForm from 'views/authentication/LoginForm';


const AuthDialog = (props: any) => {
    const {title, open, onClose, onResult, ...rest} = props;

    const handleSubmit = (val: boolean) => {
        if(!val)
            return;
        cb(true);
    }

    const cb = (val: boolean = false) => {
        onClose();
        onResult && onResult(val);
    }

    return(
        <Dialog
              sx={{
                zIndex: (theme: Theme) => theme.zIndex.tooltip + 10 // this dlg should be the highest z-index              
            }}
            maxWidth="xs" 
            open={true}
            title={title ?? "Login"}
            onClose={() => cb()}
            {...rest}
        >
            <LoginForm 
                simple
                onRegister={() => cb()}
                onForgotPassword={() => cb()}
                onSubmit={handleSubmit}/>
        </Dialog>
    ) 
}

export default AuthDialog;